import apiClient from "../web/ApiClient";
import {InstituteSummary} from "../../application/model/InstituteSummary";

/**
 * This is a utility interface to represent a researcher institute
 */
export interface ResearcherInstituteEntry {
  instituteId: number;
  instituteName?: string;
  email: string;
  position: string;
  department: string;
  newInstitute?: InstituteEntry
}

export interface InstituteSelection {
  id: number;
  name: string;
}

/**
 * This is a utility interface to represent a new institute
 */
export interface InstituteEntry {
  name: string;
  countryCode: string;
  county: string;
  town: string;
  website: string;
}

/**
 * We store this list so we don't have to recompute it all the time
 */
const instituteSummaries: InstituteSummary[] = [];

/**
 * This function is used to lazily load the institute list
 */
export async function loadInstitutes(): Promise<InstituteSummary[]> {
  // Return list if already computed
  if (instituteSummaries.length > 0) {
    return instituteSummaries;
  }

  // TODO the API is not wrapped in the AMS response wrapper. Need to change that
  await apiClient.get("/ams/api/v1/institutes", {})
  .then((response) => {
    response.data.forEach((institute: InstituteSummary) => {
      instituteSummaries.push(institute);
    })
  }).catch((error) => {
    console.warn(`Error when loading the institutes: ${error.message}`);
    return [];
  });

  return instituteSummaries;
}
